@if (data) {
  <div class="carousel-wrap">
    <owl-carousel-o [options]="carouselBanner">
      @for (item of data; track item; let i = $index) {
        <ng-template carouselSlide [dotContent]="item">
          <div [innerHTML]="item"></div>
        </ng-template>
      }
    </owl-carousel-o>
  </div>
}
